import api from './axios';

// Get next ticket number preview (ServiceNow-style: shows number on form load without incrementing)
export const getNextTicketNumber = async (requesterId = null) => {
  const params = requesterId ? `?requester_id=${requesterId}` : '';
  const response = await api.get(`/tickets/next-number${params}`);
  return response.data;
};

// Reserve ticket number (ServiceNow-style: generates number without creating ticket record)
export const reserveTicketNumber = async (requesterId = null) => {
  const response = await api.post('/tickets/reserve-number', requesterId ? { requester_id: requesterId } : {});
  return response.data;
};

// Create new ticket (or update draft ticket if draft_ticket_id is provided)
export const createTicket = async (ticketData) => {
  const response = await api.post('/tickets', ticketData);
  return response.data;
};

/** Super Admin only — cross-tenant ticket list */
export const getAllTicketsSuperAdmin = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.tenant_id) params.append('tenant_id', filters.tenant_id);
  if (filters.search) params.append('search', filters.search);
  if (filters.status) params.append('status', filters.status);
  if (filters.priority) params.append('priority', filters.priority);
  if (filters.page) params.append('page', filters.page);
  if (filters.limit) params.append('limit', filters.limit);
  const qs = params.toString();
  const response = await api.get(`/tickets/all${qs ? `?${qs}` : ''}`);
  return response.data;
};

// Get all tickets (filtered by user role)
export const getTickets = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.status) params.append('status', filters.status);
  if (filters.priority) params.append('priority', filters.priority);
  if (filters.category_id) params.append('category_id', filters.category_id);
  if (filters.assigned_to) params.append('assigned_to', filters.assigned_to);
  if (filters.unassigned) params.append('unassigned', 'true');
  if (filters.followed) params.append('followed', filters.followed);
  if (filters.ticket_ids) params.append('ticket_ids', filters.ticket_ids);
  if (filters.page) params.append('page', filters.page);
  if (filters.limit) params.append('limit', filters.limit);
  
  const response = await api.get(`/tickets?${params.toString()}`);
  return response.data;
};

// Get single ticket
export const getTicket = async (ticketId) => {
  const response = await api.get(`/tickets/${ticketId}`);
  return response.data;
};

// Update ticket
export const updateTicket = async (ticketId, ticketData) => {
  const response = await api.put(`/tickets/${ticketId}`, ticketData);
  return response.data;
};

// Delete ticket (admin only)
export const deleteTicket = async (ticketId) => {
  const response = await api.delete(`/tickets/${ticketId}`);
  return response.data;
};


